import React from 'react';
import AutoReadMore from '../../../piece/auto-read-more';

interface SubHeaderBreed {
  subtitle: string;
  description: string;
}

interface BreedSubHeaderProps {
  breed: SubHeaderBreed;
}

const BreedSubHeader: React.FC<BreedSubHeaderProps> = ({ breed }) => {
  return (
    <div className="breed-sub-head text-left">
      <h4 className="puppy-sub-head">
        <b>{breed.subtitle}</b>
      </h4>
      <AutoReadMore
        className="breed-description text-muted"
        lines={3}
        readMoreText={(
          <>
            ...
            {' '}
            <strong>read more</strong>
          </>
        )}
        readLessText={<strong>read less</strong>}
      >
        {breed.description}
      </AutoReadMore>
    </div>
  );
};

export default BreedSubHeader;
